export const list = {
  task_name: {
    name: '任务标题',
    key: 'task_name'
  },
  created_user: {
    name: '创建人',
    key: 'created_user.realname',
    show: true,
  },
  executor_user: {
    name: '执行人',
    key: 'executor_user.realname',
  },
  create_time: {
    name: '创建时间',
    key: 'create_time',
    show: true,
  },
  changed_task_stage_time: {
    name: '归档时间',
    key: 'changed_task_stage_time',
    show: true,
  },
  changed_task_stage_user: {
    name: '归档人',
    key: 'changed_task_stage_user.realname',
    show: true,
  }
};
